import React from "react";
import { Route } from "react-router-dom";
import BusinessProfilePage from "../../../features/MERCHANT/merchant-business-profile/BusinessProfilePage";
import {
  MerchantCouponEditorPage,
  MerchantCouponListPage,
} from "../../../features/MERCHANT/coupon";
import { MerchantCouponRedeemerPage } from "../../../features/MERCHANT/merchant-coupon-redeemer/pages";
import MerchantHeatmapPage from "../../../features/MERCHANT/merchant-heatmap/MerchantHeatmapPage";
import { MerchantHomePage } from "../../../features/merchant-home";
import MerchantPlanPage from "../../../features/MERCHANT/merchant-plan/MerchantPlanPage";
import ProfilePage from "../../../features/profile/pages/ProfilePage";
import MerchantRewardHistoryPage from "../../../features/MERCHANT/merchant-reward-history/MerchantRewardHistoryPage";
import MerchantSubscriptionCheckPage from "../../../features/MERCHANT/merchant-subscription-check/MerchantSubscriptionCheckPage";
import {
  EventCreatePage,
  EventDetailsPage,
  EventListPage,
  EventUpdatePage,
} from "../../../features/MERCHANT/merchant-event/pages";
import {
  CreateSurveyPage,
  EditSurveyPage,
  SurveyDetailPage,
  SurveyPage,
  SurveyResponsesPage,
} from "../../../features/MERCHANT/merchant-survey/pages";
import QRScannerCameraTab from "../../../features/qr-scanner/components/QRScannerCameraTab";
import ScannedAttendeesTab from "../../../features/qr-scanner/components/ScannedAttendeesTab";
import ScannerEventLayout from "../../../features/qr-scanner/components/ScannerEventLayout";
import QRScannerWelcome from "../../../features/qr-scanner/QRScannerWelcome";

export const merchantRoutes = (
  <>
    <Route
      index
      element={<MerchantHomePage />}
    />
    <Route
      path="home"
      element={<MerchantHomePage />}
    />
    <Route
      path="coupons"
      element={<MerchantCouponListPage />}
    />
    <Route
      path="coupons/create"
      element={<MerchantCouponEditorPage />}
    />
    <Route
      path="coupons/edit/:id"
      element={<MerchantCouponEditorPage />}
    />
    <Route
      path="coupon-redeemer"
      element={<MerchantCouponRedeemerPage />}
    />
    <Route
      path="events"
      element={<EventListPage basePath="/merchant/events" />}
    />
    <Route
      path="events/create"
      element={<EventCreatePage />}
    />
    <Route
      path="events/view/:id"
      element={<EventDetailsPage basePath="/merchant/events" />}
    />
    <Route
      path="events/edit/:id"
      element={<EventUpdatePage basePath="/merchant/events" />}
    />
    <Route
      path="events/update/:id"
      element={<EventUpdatePage basePath="/merchant/events" />}
    />
    <Route
      path="surveys"
      element={
        <SurveyPage
          basePath="/merchant/surveys"
          createPath="/merchant/surveys/create"
        />
      }
    />
    <Route
      path="surveys/create"
      element={<CreateSurveyPage />}
    />
    <Route
      path="surveys/:id"
      element={<SurveyDetailPage basePath="/merchant/surveys" />}
    />
    <Route
      path="surveys/:id/edit"
      element={<EditSurveyPage basePath="/merchant/surveys" />}
    />
    <Route
      path="surveys/:id/responses"
      element={<SurveyResponsesPage basePath="/merchant/surveys" />}
    />
    <Route
      path="qr-scanner"
      element={<QRScannerWelcome basePath="/merchant/qr-scanner" />}
    />
    <Route
      path="qr-scanner/event/:id"
      element={<ScannerEventLayout basePath="/merchant/qr-scanner" />}
    >
      <Route
        path="camera"
        element={<QRScannerCameraTab />}
      />
      <Route
        path="attendees"
        element={<ScannedAttendeesTab />}
      />
    </Route>
    <Route
      path="reward-history"
      element={<MerchantRewardHistoryPage />}
    />
    <Route
      path="heatmap"
      element={<MerchantHeatmapPage />}
    />
    <Route
      path="business-profile"
      element={<BusinessProfilePage />}
    />
    <Route
      path="profile"
      element={<ProfilePage />}
    />
    <Route
      path="my-plan"
      element={<MerchantPlanPage />}
    />
    <Route
      path="subscription-check"
      element={<MerchantSubscriptionCheckPage />}
    />
  </>
);
